// extracted by mini-css-extract-plugin
export var headerCell = "_6c-1";
export var loadingSpinnerContainer = "_6c-4";
export var loadingStateCell = "_6c-5";
export var rowWrapper = "_6c-3";
export var standaloneTable = "_6c-6";
export var table = "_6c-0";
export var white = "_6c-2";